import React from 'react';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, TextInput, TextArea, Select, RadioList, Multiform, SearchInput} from 'reactis-forms';
import {connect} from 'react-redux';
import {actions as formactions} from 'reactis-forms';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import EventEmitter from '../EventEmitter';
import isEqual from 'lodash/isEqual';
import shallowEqual from 'react-pure-render/shallowEqual';

export default class FormDB extends React.Component {

	static contextTypes = {
		store: React.PropTypes.object,
		user: React.PropTypes.object.isRequired,
		router: React.PropTypes.object,
		flashMessage: React.PropTypes.func
	};

	constructor(props, context) {
		super(props);
		this.changed = !props.id;
		this.title = false;
		this.user = context.user;
		this.state = {
			showChangedBar: false,
			extDeleted: false
		}
	}

	componentDidMount() {
		if (!this.props.form || !this.props.form.get('loaded') || this.props.forceLoad) {
			this.load();
		}
		this.changeListener = (data) => {
			this.showDiff();
		};
		EventEmitter.on(this.changeEvent + '.' + this.props.id, this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener(this.changeEvent + '.' + this.props.id, this.changeListener);
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (!shallowEqual(this.state, nextState) ||
			nextProps.id != this.props.id ||
			nextProps.tabid != this.props.tabid ||
			nextProps.form != this.props.form
		) {
			return true;
		}
		return false;
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.tab) {
			const newTab = {};
			if (nextProps.tab.title != this.title && this.title) {
				newTab.title = this.title;
			}
			if (nextProps.tab.unsave != !!this.changed) {
				newTab.unsave = !!this.changed;
			}
			if (Object.keys(newTab).length > 0) {
				this.props.updateTab(newTab);
			}
		}
		/*if (nextProps.id != this.props.id) {
			this.load(nextProps.id);
		}*/
	}

	getFormId() {
		return 'tab_' + this.props.tabid;
	}

	load(id = this.props.id) {
		if (id) {
			this.props.actions.load(this.getFormId(), this.api.fetch, {id}).then(a => {
				this.changed = false;
				//this.form.storeCheckpoint();
				if (a.error && a.error.code == 404) {
					const alert = new AlertWindow('Chyba formuláře', this.messages.notfound);
					alert.show(this.context.store.dispatch, () => {
						if (this.props.closeTab) {
							this.props.closeTab();
						}
					});
				}
				else {
					this.onLoaded(a.result);
				}
			});
		}
		else {
			if (this.api.defaults) {
				this.props.actions.getDefaults(this.getFormId(), this.api.defaults, this.getDefaultsQuery());
			}
		}
	}

	acceptChanges() {
		this.form.setValue(this.extChanges);
		this.setState({showChangedBar: false});
		this.changed = false;
		if (this.props.updateTab) {
			//this.props.updateTab({unsave: false});
		}
	}

	showDiff() {
		if (this.props.id) {
			this.props.actions.fetch(this.getFormId(), this.api.fetch, {id: this.props.id}).then(a => {
				if (a.error && a.error.code == 404) {
					this.setState({showChangedBar: true, extDeleted: true, extChangedItems: -1});
				}
				else if (!a.error) {
					this.extChanges = a.result.form;
					let changed = false;
					let changedItems = [];
					const formdata = this.getFormData();
					Object.keys(formdata).forEach((key) => {
						if (formdata[key] === undefined) {
							formdata[key] = null;
						}
						if (typeof formdata[key] === 'string') {
							formdata[key] = formdata[key].trim();
						}
						if (this.extChanges[key] !== undefined &&
							this.form.schema[key]) {

							if (!isEqual(this.extChanges[key], formdata[key])) {
								if (this.extChanges[key] === 1 && formdata[key] === true ||
									this.extChanges[key] === 0 && formdata[key] === false ||
									this.extChanges[key] === true && formdata[key] === 1 ||
									this.extChanges[key] === false && formdata[key] === 0) {
								}
								else {
									changed = true;
									changedItems.push(this.form.schema[key].label);
								}
							}
						}
					});
					if (changed) {
						this.setState({showChangedBar: true, extChangedItems: changedItems});
					}
				}
			})
		}
	}

	getDefaultsQuery() {

	}


	onLoaded(result) {
		if (this.updateTab) {
			this.updateTab(result.form);
		}
		if (this.refs.form) {
			this.refs.form.getWrappedInstance().validate();
		}
	}

	getFormData() {
		return {...this.form.getValues(true).toJS(), id: this.props.id};
	}

	saveAsNew() {
		this.save(false, true);
	}

	validate() {
		const errors = this.refs.form.getWrappedInstance().validate();
		if (errors) {
			this.displayErrors(errors);
		}
		return !errors;
	}

	save(close = false, copy = false, props = {}, callback = null) {
		document.activeElement.blur();
		if (this.validate()) {
			this.setState({showChangedBar: false, extDeleted: false});
			const data = this.getFormData();
			if (copy) {
				data.id = 0;
			}
			this.props.actions.save(this.getFormId(), this.api.save, {...data, ...props}).then((action) => {
				if (!action.error) {
					this.changed = false;
					EventEmitter.emit(this.changeEvent, action.result.form);
					this.lastSavedId = action.result.form.id;
					if (this.savePushState) {
						const urlPrefix = __URLPREFIX__;
						this.context.router.replace(urlPrefix + this.savePushState + '/' + action.result.form.id);
					}
					if (this.props.updateTab) {
						this.props.updateTab({data: action.result.form.id, unsave: false});
						if (close) {
							this.props.closeTab();
						}
						else {
							if (this.updateTab) {
								this.updateTab(action.result.form);
							}
							this.forceUpdate();
						}
					}

					if (action.result.data.message) {
						const alert = new AlertWindow('Chyba', <span dangerouslySetInnerHTML={{__html: action.result.data.message}}/>);
						alert.show(this.context.store.dispatch);
					}

					if (callback) {
						callback(action.result.form);
					}
					if (this.onSave) {
						this.onSave(action.result.form);
					}
				}
				else {
					if (action.error.code == 1001) {
						const errors = JSON.parse(action.error.message);
						this.displayErrors(errors);
					}
				}
			});
		}
	}

	onSave(data) {
		if (this.messages.saved) {
			this.context.flashMessage({message: this.messages.saved});
		}
		if (this.props.onSave) {
			this.form.reset();
			this.props.onSave(data);
		}
	}

	remove(callback = null) {
		const confirm = new ConfirmWindow('Potvrzení', this.messages.remove);
		confirm.show(this.context.store.dispatch, () => {
			this.props.actions.remove(this.getFormId(), this.api.remove, {id: this.props.id}).then((action) => {
				if (!action.error) {
					EventEmitter.emit(this.changeEvent);
					if (this.props.closeTab) {
						this.props.closeTab();
					}
					if (callback) {
						callback(action.result);
					}
					if (this.onDelete) {
						this.onDelete(action.result);
					}
				}
			});
		});
	}

	archive() {
		const confirm = new ConfirmWindow('Potvrzení', this.messages.archive);
		confirm.show(this.context.store.dispatch, () => {
			this.props.actions.archive(this.getFormId(), this.api.archive, {id: this.props.id}).then((action) => {
				if (!action.error) {
					EventEmitter.emit(this.changeEvent);
					if (this.props.closeTab) {
						this.props.closeTab();
					}
				}
			});
		});
	}

	active() {
		const confirm = new ConfirmWindow('Potvrzení', this.messages.active);
		confirm.show(this.context.store.dispatch, () => {
			this.props.actions.active(this.getFormId(), this.api.active, {id: this.props.id}).then((action) => {
				if (!action.error) {
					EventEmitter.emit(this.changeEvent);
				}
			});
		});
	}

	displayErrors(errors) {
		let messages = [];
		if (typeof errors != 'string') {
			Object.keys(errors).forEach((key) => {
				if (errors[key].childs) {
					errors[key].childs.forEach((child) => {
						Object.keys(child.errors).forEach((key2) => {
							messages.push(child.errors[key2][0]);
						});
					});
				}
				else {
					messages.push(errors[key][0]);
				}
			});
		}
		else {
			messages.push(errors);
		}
		let text;
		if (__MOBILE__) {
			text = messages.join("\n");
		}
		else {
			text = messages.map((m) => {
				return <span key={m}>{m}<br/></span>;
			});
		}
		const alert = new AlertWindow('Chyba formuláře', text);
		alert.show(this.context.store.dispatch);
	}
}



// WEBPACK FOOTER //
// ./src/components/FormDB.js